import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SalesTargetCreatePageRoutingModule } from './sales-target-create-routing.module';

import { SalesTargetCreatePage } from './sales-target-create.page';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SalesTargetCreatePageRoutingModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    IonicSelectableModule
  ],
  declarations: [SalesTargetCreatePage]
})
export class SalesTargetCreatePageModule {}
